import React from "react";
import styled from "styled-components";
import watermarkIllustration from "../../../images/watermarkIllustration.png";
import videoIllustration from "../../../images/videoIllustration.svg";

const SupportUs = ({ style, onClickIllustration, onClickText, videoSupportUs }) => (
  <Container style={style}>
    <HeaderContainer>
      <HeaderTitle>SUPPORT US!</HeaderTitle>
    </HeaderContainer>

    <Illustration
      src={videoSupportUs ? videoIllustration : watermarkIllustration}
      resizeMode="contain"
      onClick={() => {
        if (onClickIllustration) {
          onClickIllustration();
        }
      }}
    />
    <Subtitle
      onClick={() => {
        if (onClickText) {
          onClickText();
        }
      }}
    >
      {`${
        videoSupportUs ? "Paying for your video" : "Removing the watermark"
      }  helps us maintain and improve Top Nine.`}{" "}
      <br />
      From all of us working on it: <br />
      🙌 THANK YOU! 🙌
    </Subtitle>
  </Container>
);

const Container = styled.div`
  border-top: 1px solid #eee;
  padding-top: 24px;
  margin-top: 40px;
`;

const Illustration = styled.img`
  height: 160px;
  width: auto;
  margin: 4px auto;
  display: block;
  object-fit: contain;
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const HeaderTitle = styled.h2`
  background-color: transparent;
  color: #303030;
  text-align: center;
  font-size: 24px;
  align-self: stretch;
  width: 100%;
  padding: 0px 10px;
  font-family: Montserrat;
  font-weight: 500;
`;

const FooterContainer = styled.div`
  width: 100%;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0px 30px 0px;
`;

const Subtitle = styled.p`
  padding: 10px;
  color: #303030;
  text-align: center;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 400;
`;

export default SupportUs;
